import { UrlHelper } from '@/helpers/UrlHelper';

export interface ISettings {
  endpoint: string;
  helpdeskEndpoint: string;
  standaloneUrl: string;
  imageCookieDomain: string;
}

const API_PATH = '/api/m1/';

// Local default: vue.config.js proxies /api/hd/ to the helpdesk docker (localhost:8090).
const HELPDESK_PATH = '/api/hd/';

function withTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '') + '/';
}

function inferredApiEndpoint(): string {
  const apiHostname = UrlHelper.publicHostname();

  if (apiHostname === window.location.hostname) {
    return API_PATH;
  }

  return `${window.location.protocol}//${apiHostname}${API_PATH}`;
}

function apiEndpoint(): string {
  const configuredEndpoint = (process.env.VUE_APP_API_ENDPOINT || '').trim();
  const endpoint = configuredEndpoint || inferredApiEndpoint();

  return withTrailingSlash(endpoint);
}

function helpdeskEndpoint(): string {
  const configuredEndpoint = (process.env.VUE_APP_HELPDESK_ENDPOINT || '').trim();

  return withTrailingSlash(configuredEndpoint || HELPDESK_PATH);
}

function commonDomain(firstHostname: string, secondHostname: string): string {
  const firstParts = firstHostname.split('.').reverse();
  const secondParts = secondHostname.split('.').reverse();
  const commonParts: string[] = [];

  for (let index = 0; index < Math.min(firstParts.length, secondParts.length); index++) {
    if (firstParts[index] !== secondParts[index]) {
      break;
    }

    commonParts.unshift(firstParts[index]);
  }

  return commonParts.length >= 2 ? commonParts.join('.') : firstHostname;
}

const endpoint = apiEndpoint();
const apiHostname = new URL(endpoint, window.location.origin).hostname;
const standaloneUrl = (process.env.VUE_APP_STANDALONE_URL || '').trim() ||
  (apiHostname === 's2.smartpoint.ai'
    ? 'https://s2.standalone.smartpoint.ai/'
    : 'https://standalone.smartpoint.ai/');

export const settings: ISettings = {
  endpoint,
  helpdeskEndpoint: helpdeskEndpoint(),
  standaloneUrl: withTrailingSlash(standaloneUrl),
  imageCookieDomain: commonDomain(window.location.hostname, apiHostname),
};
